import type { Catalogue } from './en.ts';

export const hi: Catalogue = {
  'app.name': 'रम्मी',
  'app.install': 'इंस्टॉल',
  'app.tagline': 'अपने लोगों के लिए एक मेज़। कोई दाँव नहीं, कभी नहीं।',

  'auth.heading': 'आइए, बैठिए',
  'auth.or': 'या',
  'auth.email.label': 'ईमेल',
  'auth.password.label': 'पासवर्ड',
  'auth.signin': 'साइन इन करें',
  'auth.signup': 'खाता बनाएँ',
  'auth.haveAccount': 'पहले से सदस्य हैं?',
  'auth.newHere': 'नए हैं?',
  'auth.profile.heading': 'अपना अंदाज़ चुनें',
  'auth.shuffle': 'बदलें',
  'auth.enter': 'क्लब में आइए',
  'auth.error.email-taken': 'इस ईमेल का खाता पहले से है। साइन इन करें।',
  'auth.error.invalid-credentials': 'ईमेल या पासवर्ड ग़लत है।',
  'auth.error.invalid-email': 'यह ईमेल पता सही नहीं लगता।',
  'auth.error.weak-password': 'कम से कम 8 अक्षर रखें।',
  'auth.error.rate-limited': 'बहुत कोशिशें हो गईं। कुछ मिनट रुकें।',
  'auth.error.network': 'सर्वर से संपर्क नहीं हो सका। फिर कोशिश करें।',
  'lobby.hey': 'नमस्ते',
  'lobby.sub': 'आज किसके साथ खेलें?',
  'lobby.create.note': 'मेज़ खोलिए और अपने लोगों को बुलाइए।',
  'lobby.practice': 'अभ्यास',
  'lobby.practice.note': 'एक टैप में बॉट्स से भरी मेज़ तैयार।',
  'lobby.practice.difficulty': 'कठिनाई',
  'lobby.practice.difficulty.casual': 'सहज',
  'lobby.practice.difficulty.sharp': 'तेज़',
  'lobby.practice.difficulty.expert': 'विशेषज्ञ',
  'lobby.joinByCode': 'कोड है?',
  'lobby.codePlaceholder': 'amber-koel-42',
  'settings.signout': 'साइन आउट',
  'settings.guest': 'मेहमान — केवल इसी डिवाइस पर सहेजा गया',
  'auth.google': 'Google से जारी रखें',
  'auth.apple': 'Apple से जारी रखें',
  'auth.email': 'मुझे लिंक भेजें',
  'auth.guest': 'मेहमान के रूप में खेलें',
  'auth.retry': 'फिर कोशिश करें',
  'auth.guest.connecting': 'जुड़ रहे हैं…',
  'auth.name.label': 'मेज़ आपको किस नाम से बुलाए?',
  'auth.name.placeholder': 'आपका नाम',
  'auth.pickCharacter': 'एक चेहरा चुनें',
  'auth.adult': 'मैं 18 वर्ष या उससे अधिक का हूँ',
  'auth.adult.note':
    'यह मेज़ वयस्कों के लिए है। कोई जमा नहीं, कोई निकासी नहीं, कोई जीत की राशि नहीं — हर सत्र में अंक शून्य से शुरू होते हैं।',

  'lobby.heading': 'लॉबी',
  'lobby.friends': 'मित्र',
  'lobby.friends.empty': 'एक मेज़ पर खेलिए, और वहाँ के लोग यहाँ दिखने लगेंगे।',
  'lobby.friends.explain': 'साथ खेलने से ही मित्रता बनती है। यहाँ खोज नहीं है।',
  'lobby.rooms': 'हाल के कमरे',
  'lobby.rooms.empty': 'अभी कुछ नहीं।',
  'lobby.result.youWon':
    'पिछली बार आप जीते, {hands, plural, one {# हाथ} other {# हाथों}} में।',
  'lobby.result.youPlaced': 'पिछली बार {winner} जीते · आप {players} में से {place} रहे।',
  'lobby.result.won': 'पिछली बार {winner} जीते।',
  'lobby.create': 'कमरा बनाएँ',
  'lobby.join': 'शामिल हों',
  'lobby.watch': 'देखें',
  'lobby.invite': 'बुलाएँ',
  'lobby.seatCount': '{total, number} में से {seated, plural, one {# सीट भरी} other {# सीटें भरीं}}',

  'presence.online': 'ऑनलाइन',
  'presence.at-table': '{room} पर',
  'presence.away': 'दूर',
  'presence.offline': 'ऑफ़लाइन',

  'room.heading': 'कमरा {id}',
  'room.format': 'प्रारूप',
  'room.seats': 'सीटें',
  'room.turnTimer': 'चाल का समय',
  'room.turnTimer.value': '{seconds, number} सेकंड',
  'room.turnTimer.short': '{seconds, number}से',
  'room.guard': 'घोषणा सुरक्षा',
  'room.guard.help':
    'बिना शुद्ध क्रम वाली घोषणा को रोकता है। सबसे बड़ी भूल हट जाती है, थोड़ा कौशल भी। डिफ़ॉल्ट रूप से बंद; यह सेटिंग पूरी मेज़ को दिखती है।',
  'room.guard.on': 'चालू',
  'room.guard.off': 'बंद',
  'room.hostControls': 'होस्ट नियंत्रण',
  'room.seatLock': 'नई सीटें लॉक करें',
  'room.pauseBetweenHands': 'होस्ट अगला हाथ शुरू करे',
  'room.reentry': 'दोबारा प्रवेश',
  'room.reentry.on': 'एक बार वापसी की अनुमति',
  'room.reentry.off': 'सीधा बाहर',
  'room.reentry.help':
    '201 पार करने वाला खिलाड़ी एक बार लौट सकता है, और खेल में बचे सबसे ऊँचे स्कोर से शुरू करता है — इसलिए उसका कुल घट सकता है। बंद करने पर 201 पर उसका सत्र ख़त्म।',
  'room.startCountdown': '15 सेकंड में शुरू करें',
  'room.invite': 'निमंत्रण लिंक',
  'room.copy': 'कॉपी',
  'room.copied': 'कॉपी हो गया',
  'room.addBot': 'अभ्यास प्रतिद्वंद्वी जोड़ें',
  'room.start': 'सत्र शुरू करें',
  'room.start.hint': 'शुरू करने के लिए दो सीटें चाहिए।',
  'room.leave': 'बाहर जाएँ',
  'room.remove': 'हटाएँ',
  'room.host': 'मेज़बान',
  'room.queued': 'अगला सत्र',
  'room.queued.note': 'सत्र शुरू होते ही सीटें बंद हो जाती हैं। ये खिलाड़ी अगले सत्र में हैं।',
  'room.startsAt': '{at, date, medium} को {at, time, short} बजे शुरू',
  'room.you': 'आप',
  'room.decks':
    'दो सीटों पर एक गड्डी। तीन से छह तक दो गड्डियाँ, जैसे खेल आमतौर पर खेला जाता है। सात या उससे अधिक पर तीन, ताकि ढेरी में पत्ते बने रहें।',
  'room.decks.short': '{decks, plural, one {एक गड्डी} other {# गड्डियाँ}}',
  'room.eyebrow': 'आपकी मेज़',
  'room.crest': 'मेज़ का चिह्न',
  'room.crest.spade': 'पान का चिह्न',
  'room.crest.lotus': 'कमल का चिह्न',
  'room.crest.sun': 'सूरज का चिह्न',
  'room.crest.moon': 'चाँद का चिह्न',
  'room.untitled': 'बिना नाम की मेज़',
  'room.rename': 'मेज़ का नाम बदलें',
  'room.namePlaceholder': 'गुरुवार की महफ़िल',
  'room.fillSeat': 'यह सीट भरें',
  'room.seatMenu.invite': 'निमंत्रण लिंक कॉपी करें',
  'room.closeSeat': 'यह सीट बंद करें',
  'room.fillTable': 'मेज़ भर दें',
  'room.fillTable.note':
    '{count, plural, one {खाली कुर्सी पर एक अभ्यास प्रतिद्वंद्वी बैठाएँ} other {# खाली कुर्सियों पर अभ्यास प्रतिद्वंद्वी बैठाएँ}}',
  'room.autoFill': 'शुरू होते ही खाली सीटें भरें',
  'room.autoFill.help':
    'सत्र शुरू होने पर जो कुर्सी खाली रह जाए उस पर अभ्यास प्रतिद्वंद्वी बैठ जाता है, ताकि चार की मेज़ चार से ही शुरू हो। बीच सत्र में जाने वाले खिलाड़ी की जगह कोई नहीं लेता।',
  'room.fillSkill': 'प्रतिद्वंद्वी की मज़बूती',
  'room.seat.style': 'खेल शैली',
  'room.seat.styleFor': '{name} की खेल शैली',
  'room.seats.add': 'एक सीट जोड़ें',
  'room.seats.remove': 'एक सीट हटाएँ',
  'room.seats.count': '{seats, plural, one {# सीट} other {# सीटें}}',
  'room.qr': 'QR',
  'room.qr.hide': 'QR छिपाएँ',
  'room.qr.alt': 'मेज़ पर बैठने के लिए स्कैन करें',
  'room.qr.note': 'फ़ोन का कैमरा इस पर रखें और बैठ जाएँ।',
  'room.rules': 'मेज़ के नियम',
  'room.rules.summary':
    '{seats, number} सीटें · {seconds, number}से चाल · सुरक्षा {guard, select, on {चालू} other {बंद}}',
  'room.primer.open': 'एक हाथ कैसे चलता है',
  'room.primer.eyebrow': '30 सेकंड का दौर',
  'room.primer.draw.title': 'एक कार्ड उठाइए',
  'room.primer.draw.copy': 'अपनी बारी में बंद गड्डी चुनें या खुले पत्तों में दिख रहा कार्ड लें।',
  'room.primer.build.title': 'साफ़ समूह बनाइए',
  'room.primer.build.copy': 'क्रम और सेट बनाइए। सही घोषणा के लिए कम से कम दो क्रम चाहिए, जिनमें एक शुद्ध क्रम हो।',
  'room.primer.finish.title': 'फेंकें, फिर घोषणा करें',
  'room.primer.finish.copy': 'बारी पूरी करने के लिए एक कार्ड फेंकें। हर कार्ड सही समूह में हो तो हाथ खत्म करने के लिए घोषणा करें।',
  'room.primer.back': 'वापस',
  'room.primer.next': 'आगे',
  'room.primer.done': 'समझ गया',
  'room.primer.close': 'बंद करें',
  'room.playNow': 'अभी खेलें',
  'room.playLater': 'समय तय करें',
  'format.family.deals': 'डील',
  'format.family.pool': 'पूल',
  'room.atTheTable': 'मेज़ पर',
  'room.emptySeat': 'खाली सीट',
  'room.chooseOpponent': 'किसके साथ खेलेंगे?',
  'room.invite.note': 'इस लिंक वाला कोई भी बैठ सकता है। खाते की ज़रूरत नहीं।',

  'invite.preview.eyebrow': 'आपको मेज़ पर बुलाया गया है',
  'invite.preview.host': '{name} की मेज़',
  'invite.preview.live': 'अभी चल रहा है',
  'invite.preview.waiting': 'तैयार हो रहा है',
  'invite.preview.live.copy': 'सीट लिए बिना चालू हाथ देखें। दोस्तों के पत्ते निजी रहेंगे।',
  'invite.preview.waiting.copy': 'मेज़ खिलाड़ियों का इंतज़ार कर रही है। तैयार हों तो सीट लें।',
  'invite.preview.full.copy':
    'इस मेज़ की हर कुर्सी भरी है। शामिल होने पर आपको अगले सत्र में जगह मिलेगी।',
  'invite.preview.watch': 'लाइव देखें',
  'invite.preview.joinNext': 'अगले हाथ में जुड़ें',
  'invite.preview.join': 'मेज़ से जुड़ें',
  'invite.preview.cancel': 'बाद में',
  'room.schedule': 'शुरू होने का समय',
  'room.ready': 'जब कहें, शुरू।',
  'room.bot': 'अभ्यास',
  'bot.trait.nila': 'धैर्यवान। क्रम बनने का इंतज़ार करती हैं, ज़बरदस्ती नहीं।',
  'bot.trait.arun': 'तेज़। खुला पत्ता ज़रा भी काम का हो तो उठा लेते हैं।',
  'bot.trait.devi': 'सतर्क। दूसरे क्रम के लिए जोकर बचाकर रखती हैं।',
  'bot.trait.kabir': 'सीधे। महँगे पत्ते जल्दी फेंक देते हैं, पीछे नहीं देखते।',
  'bot.trait.meera': 'सुव्यवस्थित। ऐसा पत्ता कभी नहीं छोड़तीं जो कहीं फिट हो सके।',
  'bot.trait.ravi': 'मौक़ापरस्त। खुला पत्ता ज़रा भी काम का हो तो उठा लेते हैं।',
  'bot.trait.sana': 'तेज़। संभावनाओं पर खेलती हैं और बेकार हाथ छोड़ देती हैं।',
  'bot.trait.jai': 'सहज। न कभी छोड़ते हैं, न जल्दबाज़ी करते हैं — सीखने के लिए अच्छे।',
  'bot.trait.ila': 'सुव्यवस्थित। ऐसा पत्ता कभी नहीं फेंकतीं जो कहीं फिट हो सके।',
  'bot.trait.tara': 'तेज़। ढेरी को जल्दी पढ़ती हैं और उससे भी जल्दी खेल बंद करती हैं।',
  'bot.style.nila': 'धैर्यवान बिल्डर',
  'bot.style.arun': 'खुले पत्ते की खोज',
  'bot.style.devi': 'जोकर संभालने वाली',
  'bot.style.kabir': 'कम अंक काटने वाला',
  'bot.style.meera': 'सुव्यवस्थित फिनिशर',
  'bot.style.ravi': 'खुली ढेरी का मौक़ापरस्त',
  'bot.style.sana': 'संभावनाओं की खिलाड़ी',
  'bot.style.jai': 'सहज खिलाड़ी',
  'bot.style.ila': 'सुव्यवस्थित बिल्डर',
  'bot.style.tara': 'तेज़ फिनिशर',

  'bot.skill.casual': 'सहज',
  'bot.skill.sharp': 'तेज़',
  'bot.skill.expert': 'विशेषज्ञ',
  'bot.skill.patient': 'धैर्यवान',
  'bot.skill.opportunist': 'मौक़ापरस्त',
  'bot.skill.keeper': 'जोकर संभालने वाला',
  'bot.skill.low-card': 'कम अंक काटने वाला',
  'bot.skill.tidy': 'सुव्यवस्थित',

  'format.deals-2': 'डील · 2 हाथ',
  'format.deals-3': 'डील · 3 हाथ',
  'format.deals-6': 'डील · 6 हाथ',
  'format.pool-101': 'पूल 101',
  'format.pool-201': 'पूल 201',
  'format.deals.explain': 'तय संख्या में हाथ। सबसे कम कुल अंक जीतते हैं।',
  'format.pool.explain': 'सीमा पार की तो बाहर। अंत तक टिकने वाला जीतता है।',
  'format.note.deals-2': 'दो हाथ। जल्दी।',
  'format.note.deals-3': 'तीन हाथ। सबसे कम कुल जीतता है।',
  'format.note.deals-6': 'छह हाथ। लंबी शाम।',
  'format.note.pool-101': '101 पर बाहर। छोटा पूल।',
  'format.note.pool-201': '201 पर बाहर, एक बार वापसी।',

  'table.yourTurn': 'आपकी चाल',
  'table.turnGuide.draw': 'किसी भी ढेर से एक पत्ता उठाएँ।',
  'table.turnGuide.discard': 'फेंकने के लिए एक पत्ता चुनें।',
  'table.turnGuide.discardSelected': 'पत्ता चुना है — तैयार होने पर फेंकें।',
  'table.handProgress': 'हाथ की प्रगति',
  'table.notify.yourTurn.title': 'अब आपकी चाल है',
  'table.turnOf': '{name} सोच रहे हैं',
  'table.discard': 'फेंकें',
  'table.discard.here': 'यहाँ छोड़ें',
  'table.declare': 'घोषणा',
  'table.drop': 'ड्रॉप',
  'table.drop.first': '{points, number} पर ड्रॉप',
  'table.sort': 'क्रम',
  'table.undo': 'क्रम हटाएँ',
  'table.closed': 'बंद गड्डी',
  'table.closed.count': '{count, plural, one {# पत्ता} other {# पत्ते}} बचे',
  'table.open': 'खुला ढेर',
  'table.open.empty': 'खाली',
  'table.wild': 'वाइल्ड जोकर',
  'table.wild.short': '{rank} वाइल्ड है',
  'table.wild.explain':
    '{decks, plural, one {इस हाथ में हर {rank} वाइल्ड है।} other {इस हाथ में हर {rank} वाइल्ड है, दोनों गड्डियों में।}}',
  'table.points': 'अभी हाथ ख़त्म हो तो: {points, number}',
  'table.yourScore': 'आपका कुल',
  'table.pointsReady': 'वैध हाथ। आप घोषणा कर सकते हैं।',
  'table.handOf': 'हाथ {n, number}',
  'table.handOfTotal': '{total, number} में से हाथ {n, number}',
  'table.reconnecting': 'फिर से जुड़ रहे हैं',
  'table.autoplay.warning': '{name} ने {count, plural, one {# चाल} other {# चालें}} छोड़ी',
  'table.deckCommit': 'गड्डी प्रतिबद्ध',
  'table.leave': 'मेज़ छोड़ें',
  'table.emote': 'प्रतिक्रिया',
  'table.highlights': 'मुख्य क्षण',
  'table.history': 'पिछले हाथ',
  'table.intel': 'मेज़ जानकारी',
  'table.more': 'और',
  'history.heading': 'पिछले हाथ',
  'history.close': 'बंद करें',
  'history.empty': 'अभी तक कोई हाथ पूरा नहीं हुआ।',
  'history.hand': 'हाथ {n}',
  'history.wonBy': '{name} ने जीता',
  'history.noWinner': 'कोई घोषणा नहीं',
  'table.intel.ledger': 'देखे गए पत्ते',
  'table.intel.moves': 'सार्वजनिक चालें',
  'table.intel.empty': 'हाथ आगे बढ़ने पर सार्वजनिक पत्ते यहाँ जुड़ेंगे।',
  'table.intel.open': 'खुला पत्ता लिया',
  'table.intel.closed': 'बंद ढेर से लिया',
  'table.intel.threw': '{card} फेंका',
  'table.recovered': 'मेज़ पर वापस · आपके जाते समय {count, plural, one {# सार्वजनिक चाल हुई} other {# सार्वजनिक चालें हुईं}}',
  'table.shortcuts': 'शॉर्टकट',
  'table.shortcuts.copy': 'D बंद पत्ता · O खुला पत्ता · X चुना पत्ता फेंकें · G नया समूह · C डिक्लेयर · ? शॉर्टकट',
  'table.highlights.empty': 'अगली चाल यहाँ दिखाई देगी।',
  'table.someone': 'किसी ने',
  'table.watching': 'लाइव देख रहे हैं। दिखाने तक पत्ते निजी रहते हैं।',
  'table.highlight.dealt': 'पत्ते बाँटे गए।',
  'table.highlight.drewOpen': '{name} ने खुला पत्ता उठाया।',
  'table.highlight.drewClosed': '{name} ने बंद गड्डी से पत्ता उठाया।',
  'table.highlight.discarded': '{name} ने पत्ता फेंका।',
  'table.highlight.dropped': '{name} इस हाथ से ड्रॉप हुए।',
  'table.highlight.declared': '{name} ने घोषणा की।',
  'table.highlight.misdeclared': '{name} की घोषणा अमान्य थी।',
  'table.highlight.recycled': 'फेंके पत्तों की गड्डी फिर से मिली।',
  'table.highlight.completed': 'यह हाथ पूरा हुआ।',
  'table.recovery.heading': 'मेज़ से फिर जुड़ रहे हैं',
  'table.recovery.copy': 'आपकी आखिरी पक्की मेज़ स्थिति सुरक्षित है। कनेक्शन आने तक नई चालें रुकेंगी।',
  'table.recovery.copy.timed': 'आपकी सीट {seconds} सेकंड तक सुरक्षित है। तब तक आपकी आखिरी पक्की स्थिति सुरक्षित है।',
  'table.recovery.retry': 'अभी फिर कोशिश करें',
  'table.network.slow': 'नेटवर्क धीमा हो सकता है',
  'table.network.copy': 'कनेक्शन ठीक होने तक एनीमेशन हल्के रखे गए हैं।',
  'table.discardCoach.good': 'यह फेंकना आपके सबसे अच्छे हाथ को सुरक्षित रखता है।',
  'table.discardCoach.better': 'दूसरा पत्ता फेंकने से {points, number} अंक बच सकते हैं।',
  'table.recap': 'आपकी पिछली चाल: {draw} से उठाया, फिर फेंका।',
  'table.recap.open': 'खुले ढेर',
  'table.recap.closed': 'बंद ढेर',
  'table.fullscreen': 'मेज़ पर ध्यान दें',
  'table.fullscreen.exit': 'ध्यान मोड बंद करें',
  'table.assist.run': 'यहाँ एक क्रम बन रहा है।',
  'table.assist.set': 'यह जोड़ी एक पत्ते से सेट बन सकती है।',
  'table.reaction.nice': 'बढ़िया',
  'table.reaction.run': 'बढ़िया क्रम',
  'table.reaction.close': 'बस थोड़ा और',
  'table.reaction.wild': 'वाइल्ड!',
  'table.spectating': 'देख रहे हैं। अगले सत्र में आपकी सीट है।',
  'table.eliminated': 'बाहर',
  'seat.cards': '{count, plural, one {# पत्ता} other {# पत्ते}}',
  'points.short': '{points, number} अंक',
  'table.dropped': 'ड्रॉप किया',
  'table.order.next': 'अगला',
  'table.order.away': '+{count, number}',
  'table.autoDropped': 'समय समाप्त',
  'table.youDropped': 'आपने यह हाथ छोड़ दिया — {points, number} अंक',
  'table.waitingForHost': 'मेज़बान के शुरू करने का इंतज़ार।',
  'table.yourTurn.timed': 'आपकी चाल · {seconds, number}से',
  'table.missWarning':
    '{count, plural, one {# चाल} other {# चालें}} छूटीं। एक और छूटी तो {points, number} अंक पर ड्रॉप।',
  'table.timedOut': 'आपका समय बीत गया। न्यूनतम चाल आपकी ओर से चल दी गई।',

  'log.drew.closed': '{name} ने बंद गड्डी से उठाया',
  'log.drew.discard': '{name} ने खुला पत्ता लिया',
  'log.discarded': '{name} ने फेंका',
  'log.dropped': '{name} ने ड्रॉप किया',
  'log.declared.valid': '{name} ने घोषणा की',
  'log.declared.invalid': '{name} की घोषणा टिकी नहीं',
  'log.recycled': 'खुला ढेर फिर से गड्डी में मिला दिया गया',
  'log.autoplay': '{name} का समय बीता, न्यूनतम चाल चली गई',

  'group.pure': 'शुद्ध क्रम',
  'group.impure': 'क्रम',
  'group.set': 'सेट',
  'group.incomplete': 'अभी संयोजन नहीं',
  'group.new': 'नया समूह',
  'group.selected': '{count, plural, one {# पत्ता चुना} other {# पत्ते चुने}}',

  'declare.heading': 'घोषणा',
  'declare.explain': 'सर्वर को ठीक यही दिखेगा।',
  'declare.finish': 'अंतिम पत्ता',
  'declare.finish.pick': 'नीचे रखने के लिए पत्ता चुनें।',
  'declare.finish.selected': 'चुना पत्ता इस्तेमाल करें',
  'declare.finish.change': 'दूसरा पत्ता चुनें',
  'declare.drawFirst': 'पहले एक पत्ता उठाएँ, फिर अपना अंतिम पत्ता चुनें।',
  'declare.waitTurn': 'अपनी बारी में पत्ता उठाने के बाद घोषणा करें।',
  'declare.confirm': 'घोषणा पक्की करें',
  'declare.cancel': 'वापस',
  'declare.invalid': 'यह समूहन वैध नहीं है। फिर भी घोषणा की तो 80 अंक।',
  'declare.valid': 'दो क्रम, एक शुद्ध। यह टिकेगी।',
  'declare.guardBlocked': 'कमरे की घोषणा सुरक्षा चालू है और इस हाथ में शुद्ध क्रम नहीं है।',

  'show.heading': 'शो',
  'show.explain': 'अंक गिनने से पहले अपना हाथ जमा लें। {seconds, number} सेकंड।',
  'show.submit': 'व्यवस्था भेजें',
  'show.winner': '{name} ने घोषणा की',
  'show.waiting': '{names} का इंतज़ार',
  'show.submitted': 'व्यवस्था भेज दी गई।',
  'show.arranging': 'जमा रहे हैं',
  'show.yourTurnToArrange': 'अपना हाथ जमाकर भेजें। सबके भेजते ही गिनती शुरू।',

  'summary.heading': 'हाथ {n, number}',
  'summary.points': 'अंक',
  'summary.total': 'कुल',
  'summary.reentry': '{from, number} पर 201 पार · {to, number} से वापसी',
  'summary.best': 'सबसे अच्छा संभव था {points, number}',
  'summary.next': 'अगला हाथ {seconds, number} में',
  'summary.continue': 'आगे',
  'summary.continue.in': 'आगे · {seconds, number}से',
  'summary.replay': 'अंत दोबारा देखें',
  'summary.replay.close': 'दोबारा देखना बंद करें',
  'summary.replay.title': '{name} की अंतिम चाल',
  'summary.replay.copy': 'अंतिम व्यवस्था, एक-एक पत्ता फिर से बाँटा गया।',
  'summary.review': 'अपनी चालें देखें',
  'summary.review.close': 'समीक्षा बंद करें',
  'summary.review.title': 'आपकी चालों का क्रम',
  'summary.review.copy': 'आपके सामने आई जानकारी और छोड़े गए पत्तों का निजी रिकॉर्ड।',
  'summary.review.closed': 'बंद ढेर से लिया',
  'summary.review.open': 'खुला पत्ता लिया {card}',
  'summary.review.discard': 'फेंका {card}',
  'summary.expert.instead':
    'आपने {yours} फेंका; विशेषज्ञ {theirs} फेंकता — {points, plural, one {# अंक} other {# अंक}} सस्ता।',
  'summary.expert.missedDeclaration':
    'यह हाथ तभी जीता हुआ था — यहाँ {card} फेंकते तो घोषणा हो जाती।',
  'summary.coach.heading': 'हाथ कोच',
  'summary.coach.grouping': 'अलग समूहन से {points, number} अंक बच सकते थे।',
  'summary.coach.pure': 'इस हाथ में एक शुद्ध क्रम बन सकता था।',
  'summary.coach.deadwood': '{count, plural, one {# पत्ते की सुरक्षित जगह नहीं थी।} other {# पत्तों की सुरक्षित जगह नहीं थी।}}',
  'summary.coach.show': 'बेहतर समूहन देखें',
  'summary.coach.hide': 'समूहन छिपाएँ',
  'outcome.won': 'जीते',
  'outcome.lost': 'हारे',
  'outcome.first-drop': 'पहला ड्रॉप',
  'outcome.middle-drop': 'ड्रॉप',
  'outcome.auto-drop': 'समय बीता',
  'outcome.invalid-declaration': 'अवैध घोषणा',

  'session.heading': 'सत्र पूरा',
  'session.winner': '{name} जीते',
  'session.winner.tie': 'बराबरी',
  'session.rematch': 'फिर से',
  'session.leave': 'बाहर',
  'session.share': 'रिकैप शेयर करें',
  'session.shared': 'रिकैप शेयर हुआ',
  'session.details.show': 'सेशन विवरण देखें',
  'session.details.hide': 'सेशन विवरण बंद करें',
  'session.byHand': 'हाथ दर हाथ',
  'session.hands': '{n, plural, one {# हाथ} other {# हाथ}}',
  'session.hand': 'हाथ',
  'session.margin': '{points, number} अंकों से जीत',
  'session.margin.none': 'शीर्ष पर बराबरी',
  'session.celebrate': 'फिर से जश्न',
  'session.you': 'आप',
  'session.out': 'बाहर',
  'session.outAt': 'हाथ {n, number} में बाहर',
  'session.reentry': '{to, number} से वापसी (हाथ {n, number})',
  'session.reentry.note':
    'दोबारा प्रवेश पर स्कोर खेल में बचे सबसे ऊँचे स्कोर पर आ जाता है, इसलिए हाथों का जोड़ नीचे दिए कुल से ज़्यादा हो सकता है।',
  'session.tab.standings': 'तालिका',
  'session.tab.progress': 'प्रगति',
  'session.tab.hands': 'हाथ',
  'session.stat.won': 'जीते हाथ',
  'session.stat.average': 'औसत प्रति हाथ',
  'session.stat.best': 'सर्वश्रेष्ठ हाथ',
  'session.stat.drops': 'ड्रॉप',
  'session.award.wins': 'सबसे ज़्यादा हाथ जीते',
  'session.award.steady': 'सबसे स्थिर',
  'session.award.tight': 'सबसे नज़दीकी',
  'session.award.wins.value': '{n, plural, one {# हाथ} other {# हाथ}}',
  'session.tiltNudge': '{n} सत्रों से जीत नहीं मिली। जल्दी नहीं — प्रैक्टिस मोड में कोई दांव नहीं, अपनी रफ़्तार से खेलें।',
  'session.award.points.value': '{points, number} अंक',
  'session.chart.hand': 'हाथ {n, number} के बाद',
  'session.chart.start': 'पहले हाथ से पहले',
  'session.chart.empty': 'कोई हाथ नहीं खेला गया।',
  'session.chart.a11y':
    'हर हाथ के बाद का स्कोर। सत्र में आगे-पीछे जाने के लिए तीर कुंजियाँ दबाएँ; नीचे के आँकड़े बदलते रहेंगे।',

  'personal.eyebrow': 'आपकी फॉर्म',
  'personal.heading': 'निजी आंकड़े',
  'personal.device': 'इस डिवाइस पर',
  'personal.account': 'आपका खाता',
  'personal.sessions': 'सत्र',
  'personal.winRate': 'हाथ जीतने की दर',
  'personal.avgPoints': 'औसत अंक',
  'personal.drops': 'ड्रॉप',

  'achievement.eyebrow': 'सिर्फ़ आपके लिए',
  'achievement.heading': 'टेबल पड़ाव',
  'achievement.first-win.title': 'पहला हाथ जीता',
  'achievement.first-win.copy': 'आपकी दर्ज पहली हाथ-जीत।',
  'achievement.five-wins.title': 'पाँच हाथ जीते',
  'achievement.five-wins.copy': 'टेबल पर बिताए असली समय की निशानी।',
  'achievement.steady-player.title': 'नियमित खिलाड़ी',
  'achievement.steady-player.copy': 'तीन पूरे सत्र।',
  'achievement.calm-table.title': 'शांत टेबल',
  'achievement.calm-table.copy': 'बिना ड्रॉप का तीन-हाथ सत्र।',
  'achievement.next': '"{title}" से बस {remaining} कदम दूर।',

  'verify.heading': 'गड्डी सत्यापन',
  'verify.explain':
    'बाँटने से पहले गड्डी का क्रम प्रतिबद्ध किया गया और बाद में उजागर। इससे सिद्ध होता है कि क्रम पहले से तय था और बीच में बदला नहीं गया। यह सिद्ध नहीं करता कि फेंटना पूरी तरह यादृच्छिक था।',
  'verify.check': 'इस हाथ को जाँचें',
  'verify.copy': 'रसीद कॉपी करें',
  'verify.copied': 'रसीद कॉपी हो गई',
  'verify.ok': 'उजागर गड्डी प्रतिबद्धता से मेल खाती है।',
  'verify.fail': 'उजागर गड्डी मेल नहीं खाती। कृपया इसकी सूचना दें।',
  'verify.commit': 'प्रतिबद्धता',

  'settings.heading': 'सेटिंग्स',
  'settings.section.play': 'खेल',
  'settings.section.look': 'रूप',
  'settings.section.access': 'मेज़ पढ़ना',
  'settings.experience.learning': 'सीख रहे हैं',
  'settings.experience.regular': 'नियमित',
  'settings.experience.expert': 'विशेषज्ञ',
  'settings.experience.custom': 'आपका अपना मेल',
  'settings.experience.help':
    'तय करता है कि मेज़ आपको कितना समझाए। नीचे कुछ भी बदलें और यह आपका अपना मेल बन जाएगा।',
  'settings.theme': 'थीम',
  'settings.theme.light': 'हल्की',
  'settings.theme.dark': 'गहरी',
  'settings.theme.system': 'सिस्टम',
  'settings.deck': 'गड्डी के रंग',
  'settings.deck.two': 'दो रंग',
  'settings.deck.four': 'चार रंग',
  'settings.tableSkin': 'मेज़ का रूप',
  'settings.tableSkin.jade': 'जेड लाउंज',
  'settings.tableSkin.midnight': 'मिडनाइट वायलेट',
  'settings.tableSkin.noir': 'नॉयर मार्बल',
  'settings.tableSkin.sunset': 'सनसेट क्लब',
  'settings.tableSkin.seasonal': 'मौसमी क्लब',
  'settings.cardBack': 'अपना कार्ड बैक',
  'settings.cardBack.club': 'क्लब वायलेट',
  'settings.cardBack.aurora': 'ऑरोरा',
  'settings.cardBack.ruby': 'रूबी',
  'settings.cardBack.ivory': 'आइवरी',
  'settings.playerAccent': 'खिलाड़ी का रंग',
  'settings.playerAccent.violet': 'वायलेट',
  'settings.playerAccent.rose': 'रोज़',
  'settings.playerAccent.aqua': 'एक्वा',
  'settings.playerAccent.gold': 'गोल्ड',
  'settings.accessibility': 'सुविधा और पहुँच',
  'settings.cardSize.compact': 'छोटे कार्ड',
  'settings.cardSize.comfortable': 'आरामदायक कार्ड',
  'settings.cardSize.large': 'बड़े कार्ड',
  'settings.handedness.right': 'दाएँ हाथ का लेआउट',
  'settings.handedness.left': 'बाएँ हाथ का लेआउट',
  'settings.highContrast': 'उच्च कॉन्ट्रास्ट',
  'settings.motion': 'गति',
  'settings.motion.full': 'पूरी',
  'settings.motion.reduced': 'कम',
  'settings.motion.none': 'कोई नहीं',
  'settings.motion.help':
    '"कम" वही हलचल रखता है जो कुछ बताती है — पत्ता हाथ बदलना, समूह बनना, आपकी बारी आना — और सजावट हटा देता है। आपके डिवाइस की सेटिंग कम माँगे तो वही चलेगी।',
  'settings.turnAlert': 'मेरी बारी आने पर ध्वनि',
  'settings.sound': 'कार्ड ध्वनियाँ',
  'settings.turnNotifications': 'जब बारी मेरी हो तो सूचित करें (टैब बैकग्राउंड में हो तब भी)',
  'settings.confirmDiscard': 'फेंकने से पहले पुष्टि',
  'settings.quickPlay': 'तेज़ खेल — पत्ता उठाने पर अपने-आप क्रम लगाएँ और प्रभाव कम करें',
  'settings.expertMode': 'विशेषज्ञ मेज़ — सघन नियंत्रण और हाथ की स्थिति',
  'settings.tableIntel': 'मेज़ जानकारी — देखे गए पत्ते और सार्वजनिक चालें ट्रैक करें',
  'settings.gameplayGuidance': 'मेल्ड प्रगति और खेल के सुझाव दिखाएँ',
  'settings.language': 'भाषा',
  'settings.close': 'बंद करें',


  'a11y.hand': 'आपका हाथ, {count, plural, one {# पत्ता} other {# पत्ते}}',
  'a11y.card': '{suit} का {rank}',
  'a11y.joker': 'जोकर',
  'a11y.group': 'समूह {n, number}, {kind}',
  'a11y.keyboard':
    'तीर कुंजियाँ ट्रे में चलती हैं। स्पेस पत्ता उठाता है, एंटर रखता है। D बंद गड्डी से उठाता है, Shift D खुला पत्ता लेता है। S क्रम लगाता है।',
  'a11y.turnTimer': 'इस चाल में {seconds, number} सेकंड बचे',

  'error.connecting': 'जुड़ रहे हैं…',
  'error.connection': 'संपर्क टूटा। फिर से कोशिश जारी।',
  'error.offline': 'मेज़ तक नहीं पहुँच पा रहे। कोशिश जारी है।',
  'error.connected': 'वापस जुड़ गए।',
  'error.rate-limited': 'ज़रा धीरे।',
  'error.not-your-turn': 'अभी आपकी चाल नहीं।',
  'error.must-draw': 'पहले पत्ता उठाएँ।',
  'error.must-discard': 'पहले फेंकें।',
  'error.card-not-held': 'वह पत्ता आपके हाथ में नहीं है।',
  'error.no-room': 'वह कमरा अब नहीं है।',
  'error.stale-state': 'मेज़ बदल गई। आपका दृश्य ताज़ा कर दिया गया है।',
  'error.bad-action': 'उस चाल को समझा नहीं जा सका।',
  'error.guard-no-pure-sequence': 'घोषणा सुरक्षा ने रोका: शुद्ध क्रम नहीं है।',
  'error.generic': 'कुछ गड़बड़ हुई।',

  'rules.back': '\u2039 वापस',
  'rules.heading': 'कैसे खेलें',
  'rules.lede':
    'भारतीय रम्मी, तेरह पत्ते। अगर आपने कभी नहीं खेला, तो जो कुछ चाहिए वह इसी पन्ने पर है — पढ़ने में लगभग चार मिनट, और समझने में एक हाथ।',

  'rules.goal.title': 'करना क्या है',
  'rules.goal.body':
    'आपके पास तेरह पत्ते होते हैं। आपको तेरहों को सही समूहों में सजाना है — एक ही रंग के लगातार पत्तों का क्रम, या अलग-अलग रंगों के एक ही अंक के समूह। जो सबसे पहले तेरहों सजा कर घोषणा कर दे, वह हाथ जीतता है। बाकी सबको उनके बचे पत्तों के अंक मिलते हैं, और रम्मी में अंक बुरे होते हैं: सबसे कम कुल वाला जीतता है।',

  'rules.table.title': 'मेज़',
  'rules.table.body':
    'दो गड्डियाँ मिलाकर फेंटी जाती हैं, इसलिए हर पत्ता दो बार होता है। बीच में दो ढेरियाँ होती हैं: बंद गड्डी, जो नीचे मुँह किए होती है, और खुली ढेरी, जो ऊपर मुँह किए होती है। आप दोनों में से किसी का ऊपरी पत्ता ले सकते हैं।',
  'rules.table.wild':
    'शुरू में एक पत्ता खोला जाता है जो जोकर तय करता है। उसका जो अंक हो, उसी अंक के चारों रंग उस हाथ के लिए जोकर बन जाते हैं, और छपे हुए जोकर भी। जोकर किसी भी कमी वाले पत्ते की जगह ले सकता है, और हाथ हारने पर उसके कोई अंक नहीं लगते।',

  'rules.turn.title': 'आपकी बारी',
  'rules.turn.draw': 'एक पत्ता उठाइए — बंद गड्डी से, या खुली ढेरी पर दिख रहा पत्ता।',
  'rules.turn.arrange': 'अपने पत्तों को समूहों में सजाइए। जितनी बार चाहें बदल सकते हैं, अपनी बारी में भी और उसके बाहर भी।',
  'rules.turn.discard': 'एक पत्ता खुली ढेरी पर फेंक दीजिए। अब आपके पास फिर तेरह हैं और बारी आगे बढ़ जाती है।',
  'rules.turn.note':
    'हर बारी में एक पत्ता अंदर, एक बाहर। खुली ढेरी से उठाया गया पत्ता उसी बारी में वापस नहीं फेंका जा सकता।',

  'rules.combos.title': 'सही समूह क्या माने जाते हैं',

  'rules.pure.title': 'शुद्ध क्रम',
  'rules.pure.body':
    'एक ही रंग के तीन या अधिक लगातार पत्ते, बिना किसी जोकर के। इक्का नीचे भी चलता है (A-2-3) और ऊपर भी (Q-K-A)। कम से कम एक शुद्ध क्रम होना ज़रूरी है, और यही इस पन्ने की सबसे अहम बात है।',
  'rules.pure.yes': 'पान के तीन लगातार पत्ते, कोई जोकर नहीं — शुद्ध क्रम।',
  'rules.pure.no': 'अंक सही हैं, पर रंग अलग-अलग। यह क्रम है ही नहीं।',
  'rules.pure.corner': 'कोना नहीं मुड़ता: K-A-2 क्रम नहीं है।',

  'rules.impure.title': 'अशुद्ध क्रम',
  'rules.impure.body':
    'वही बात, पर बीच की कमी जोकर से पूरी होती है। यह सच्चा क्रम है और आपके दो क्रमों में गिना जाता है — बस यह शुद्ध वाला नहीं है।',
  'rules.impure.yes': 'जोकर यहाँ पान के 6 की जगह खड़ा है।',

  'rules.set.title': 'सेट',
  'rules.set.body':
    'एक ही अंक के तीन या चार पत्ते, हर एक अलग रंग का। किसी की जगह जोकर आ सकता है। दो गड्डियाँ होने के कारण नीचे वाली गलती से बचिए।',
  'rules.set.yes': 'तीन नहले, तीनों अलग रंग — सेट।',
  'rules.set.no': 'हुकुम के दो नहले। एक ही रंग दो बार कभी सेट नहीं बनता।',

  'rules.declare.title': 'हाथ खत्म करना',
  'rules.declare.body':
    'जब आपका चौदहवाँ पत्ता फेंकने पर पीछे पूरे तेरह बचें, तब वह पत्ता फेंक कर घोषणा कीजिए। घोषणा सही होने के लिए ये तीनों शर्तें पूरी होनी चाहिए:',
  'rules.declare.r1': 'तेरहों पत्ते किसी न किसी समूह में हों — कुछ भी बचा हुआ न हो।',
  'rules.declare.r2': 'उनमें कम से कम दो समूह क्रम हों।',
  'rules.declare.r3': 'उन क्रमों में कम से कम एक शुद्ध हो — उसमें कोई जोकर न हो।',
  'rules.declare.warn':
    'इनके बिना घोषणा करना खेल की सबसे महँगी भूल है: सीधे 80 अंक और आप उस हाथ से बाहर। घोषणा से पहले दो बार गिनिए।',

  'rules.score.title': 'अंक कैसे बनते हैं',
  'rules.score.body':
    'जीतने वाले को शून्य। बाकी सब अपने उन पत्तों के अंक जोड़ते हैं जो किसी सही समूह में सुरक्षित नहीं हैं।',
  'rules.score.win': 'हाथ जीतना',
  'rules.score.win.v': '0',
  'rules.score.card': 'अंकों वाले पत्ते',
  'rules.score.card.v': 'जितना अंक — 7 के 7 अंक',
  'rules.score.wild': 'इक्का, बादशाह, बेगम, गुलाम',
  'rules.score.wild.v': 'हर एक के 10। जोकर के कोई अंक नहीं।',
  'rules.score.cap': 'एक हाथ में अधिकतम',
  'rules.score.cap.v': '80',
  'rules.score.first': 'पहली बारी से पहले हटना',
  'rules.score.first.v': '20',
  'rules.score.middle': 'बाद में हटना, या समय बीत जाना',
  'rules.score.middle.v': '40',
  'rules.score.invalid': 'बिना तैयारी घोषणा करना',
  'rules.score.invalid.v': '80',
  'rules.score.protect':
    'कितना बचता है, यह इस पर है कि आप कहाँ तक पहुँचे। शुद्ध क्रम न हो तो कुछ नहीं बचता और पूरा हाथ आपके खिलाफ गिना जाता है। शुद्ध क्रम हो पर कुल एक ही क्रम हो, तो सिर्फ उसी शुद्ध क्रम के पत्ते सुरक्षित हैं। जब दो क्रम हों जिनमें एक शुद्ध हो, तब हर सही समूह गिना जाता है और सिर्फ बचे हुए पत्तों के अंक लगते हैं। इसीलिए शुद्ध क्रम सबसे ज़रूरी है।',

  'rules.formats.title': 'प्रारूप',
  'rules.formats.deals':
    'डील — तय संख्या में हाथ, दो, तीन या छह। अंत में सबसे कम कुल वाला जीतता है।',
  'rules.formats.pool':
    'पूल — सबका कुल जुड़ता जाता है और 101 या 201 पार करते ही खिलाड़ी बाहर। आखिर में बचा खिलाड़ी जीतता है। 201 में पार करने वाला एक बार वापस आ सकता है, और खेल में बचे सबसे ऊँचे स्कोर से शुरू करता है।',

  'rules.tips.title': 'चार बातें जो अंक बचाएँगी',
  'rules.tips.pure':
    'पहले शुद्ध क्रम बनाइए। उसके बिना पूरा हाथ आपके खिलाफ गिना जाता है, बाकी कितना भी सजा हो।',
  'rules.tips.arrange':
    'खेलते-खेलते पत्तों को समूहों में रखते जाइए। अंक उसी सजावट पर लगते हैं जो आपने सचमुच बनाई, उस पर नहीं जो बना सकते थे — और मेज़ आपको बताती रहती है कि अभी वह कितने की है।',
  'rules.tips.drop':
    'खराब हाथ छोड़ देना ही ठीक है। पहली बारी में बीस अंक, अंत के अस्सी से सस्ते हैं।',
  'rules.tips.wild':
    'जोकर सँभाल कर रखिए। हारने पर उनके अंक नहीं लगते, और वे ऐसा क्रम पूरा कर सकते हैं जो कभी न बनता।',

  'rules.play': 'समझ गया — खेलते हैं',
  'rules.full': 'पूरे नियम पढ़ें \u203a',
  'rules.new': 'रम्मी में नए हैं? खेलना सीखिए \u203a',
};
